import feefoScript from './feefo-script';
const pdpFilter = () => {
    // CPW PDP SORT + LOAD MORE + FILTER STARTS
    const pdpLoadMoreDealsButtonPaym = document.querySelector(
        '[data-filters-action="pdp-load-more-deals-new"]'
    );
    const pdpLoadMoreDealsButtonPaymUpgrade = document.querySelector(
        '[data-filters-action="pdp-load-more-deals-upgrade"]'
    );
    const pdpHandsetLoadMorePaym = document.querySelector(
        '.handsetLoadMorePaym'
    );
    const pdpHandsetLoadMoreUpgrade = document.querySelector(
        '.handsetLoadMoreUpgrade'
    );
    const pdpSpinner = document.querySelector(
        '[data-pdp-loading-overlay]'
    );
    const pdpSortSelect = document.querySelector(
        'select[name="pdpSort"][data-pdp-sort-by]'
    );
    const loaderPaymDealsContainer = document.querySelector(
        '[data-results-container-paym]'
    );
    const loaderPaymUpgradeDealsContainer = document.querySelector(
        '[data-results-container-paym-upgrade]'
    );
    const pdpPaymDealFilterContainer = document.querySelector(
        '[pdp-paym-deal-filter-container]'
    );
    const pdpPaymUpgradeDealFilterContainer = document.querySelector(
        '[pdp-paymupgrade-deal-filter-container]'
    );
    const sort = () => {
        const pdpLoadMoreButton =
            pdpHandsetLoadMorePaym
                ? (pdpHandsetLoadMorePaym.classList.contains('hide')
                    ? pdpLoadMoreDealsButtonPaymUpgrade
                    : pdpLoadMoreDealsButtonPaym)
                : (pdpHandsetLoadMoreUpgrade.classList.contains('hide')
                    ? pdpLoadMoreDealsButtonPaym
                    : pdpLoadMoreDealsButtonPaymUpgrade);
        const dealType = pdpLoadMoreButton.dataset.dealType;
        const sortInput = document.getElementById(`pdpSort${dealType === 'new' ? 'Paym' : 'PaymUpgrade'}`);
        const activeSortValue = pdpSortSelect.value;
        sortInput.value = activeSortValue;
        pdpSortSelect.value = activeSortValue;
        pdpFilterHandler(pdpLoadMoreButton);
    };
    const initPdpFilters = () => {
        document.querySelectorAll('.cpwPdpInputFilter').forEach((el) => {
            el.addEventListener('click', () => {
                processPdpFilters(el);
            });
        });
    };
    const initPdpFilterToggle = () => {
        document.querySelectorAll('[pdp-deal-filter]').forEach((el) => {
            el.addEventListener('click', (e) => {
                pdpDealFilterToggle(e, el);
            });
        });
    };
    const initPdpFilterNetworks = () => {
        document.querySelectorAll('.handsetDealNetworkName').forEach((el) => {
            el.addEventListener('click', () => {
                processFilterNetwork(el);
            });
        });
    };
    const initFilterContainers = () => {
        document.querySelectorAll('.pdpDealFilterContainer').forEach((el) => {
            el.classList.add('hide');
        });
        document.querySelectorAll('.handsetDealFilter').forEach((el) => {
            el.dataset.activeStatus = '0';
        });
    };
    const initFilterApplyButtons = () => {
        ['[pdp-paymupgrade-apply-filter]', '[pdp-paym-apply-filter]']
            .forEach((sel) => {
                const el = document.querySelector(sel);
                if (el) {
                    el.addEventListener('click', e => pdpApplyFilter(e, el));
                }
            });
    };
    const pdpHideContractPriceTab = () => {
        const pricePane = document.getElementById('pdpPrice');
        const detailsPane = document.getElementById('pdpProductDetails');
        document.querySelectorAll('.pdpTabs').forEach((el) => {
            const pane = document.getElementById(el.dataset.ref);
            el.classList.remove('active');
            pane.classList.remove('in', 'active');
            if (el.dataset.ref === 'pdpPrice') {
                el.classList.add('hide');
                pricePane.classList.add('hide');
            }
            if (el.dataset.ref === 'pdpProductDetails') {
                el.classList.add('active');
                detailsPane.classList.add('in', 'active');
            }
        });
    };
    const pdpShowContractPriceTab = () => {
        const priceTab = document.getElementById('pdpPrice');
        document.querySelectorAll('.pdpTabs').forEach((el) => {
            el.classList.remove('active');
            document.getElementById(el.dataset.ref).classList.remove('in', 'active');
            if (el.dataset.ref === 'pdpPrice') {
                el.classList.remove('hide');
                el.classList.add('active');
            }
        });
        if (priceTab != null) {
            priceTab.classList.remove('hide');
            priceTab.classList.add('in', 'active');
        }
    };
    const equilisePdpDeals = () => {
        const handsetContract = document.querySelector('.handsetContractDeal');
        const handsetPaym = document.querySelector('.handsetPaymDeal');
        const handsetUpgrade = document.querySelector('.handsetPaymUpgradeDeal');
        if (handsetContract && handsetContract.classList.contains('paymentChecked')) {
            if (handsetPaym && handsetPaym.classList.contains('paymentChecked')) {
                equilisePdpDealsHeight('.pdp-deals-promo-paym');
            } else if (handsetUpgrade && handsetUpgrade.classList.contains('paymentChecked')) {
                equilisePdpDealsHeight('.pdp-deals-promo-paymupgrade');
            } else {
                ['.pdp-deals-promo-paym', '.pdp-deals-promo-paymupgrade']
                    .forEach(sel => equilisePdpDealsHeight(sel));
            }
        }
    };
    const equilisePdpDealsHeight = (selector) => {
        let promoTiles = document.querySelectorAll(selector);
        if (!promoTiles.length) {
            return;
        }
        if (window.innerWidth > 767) {
            let totalCnt = 0;
            let pdpCnt = 0;
            let increaseHeight = 0;
            let tileCls = [];
            let pdpPromoCnt = promoTiles.length;
            promoTiles.forEach((tile) => {
                if (tile.dataset.equalise == '0') {
                    tile.dataset.equalise = '1';
                    totalCnt++;
                    let dataRef = tile.getAttribute('data-ref');
                    if (pdpCnt === 3) {
                        pdpCnt = 0;
                        increaseHeight = 0;
                        tileCls = [];
                    }
                    pdpCnt++;
                    tileCls.push(`pdpDealsPromo${dataRef}`);
                    let pdpDealPromo = 0;
                    document.querySelectorAll('.pdpPromoBox').forEach((box) => {
                        if (box.dataset.equalise == '0' && box.dataset.ref === dataRef) {
                            pdpDealPromo += box.offsetHeight;
                            box.dataset.equalise = '1';
                        }
                    });
                    if (pdpDealPromo > increaseHeight) {
                        increaseHeight = pdpDealPromo;
                    }
                    if ((pdpCnt === 3 || totalCnt === pdpPromoCnt) && increaseHeight > 0 && tileCls.length > 0) {
                        tileCls.forEach((cls) => {
                            let el = document.querySelector(`.${cls}`);
                            if (el) {
                                el.style.minHeight = `${increaseHeight}px`;
                            }
                        });
                    }
                }
            });
        } else {
            document.querySelectorAll(selector).forEach((tile) => {
                tile.style.minHeight = 'auto';
            });
        }
    };
    // const resetPdpDeals = () => {
    //     ['.pdp-deals-promo-paym', '.pdp-deals-promo-paymupgrade']
    //         .forEach(sel => resetPdpDealsEqualise(sel));
    // };
    // const resetPdpDealsEqualise = (selector) => {
    //     let promoTiles = document.querySelectorAll(selector);
    //     if (!promoTiles.length) {
    //         return;
    //     }
    //     if (window.innerWidth > 767) {
    //         promoTiles.forEach((tile) => {
    //             tile.dataset.equalise = '0';
    //             let dataRef = tile.getAttribute('data-ref');
    //             document.querySelectorAll('.pdpPromoBox').forEach((box) => {
    //                 if (box.dataset.ref === dataRef) {
    //                     box.dataset.equalise = '0';
    //                 }
    //             });
    //         });
    //     }
    // };
    const pdpLoadMoreDeals = (e, pdpLoadMoreDealsButton) => {
        e.preventDefault();
        pdpLoadMoreDealsButton.disabled = true;
        pdpLoadMoreDealsButton.style.pointerEvents = 'none';
        pdpLoadMoreDealsButton.style.opacity = '0.5';
        pdpLoadMoreDealsButton.setAttribute('aria-disabled', 'true');
        pdpPrepareLoading(pdpLoadMoreDealsButton);
        pdpFilterHandler(pdpLoadMoreDealsButton, false);
    };
    const pdpPrepareLoading = (pdpLoadMoreDealsButton) => {
        const pageState = parseInt(pdpLoadMoreDealsButton.dataset.pageState);
        pdpLoadMoreDealsButton.dataset.pageState = pageState + 1;
        const dealType = pdpLoadMoreDealsButton.dataset.dealType;
        pdpLoadMoreDealsButton.classList.add('hide');
        showHidePdpLoader(
            dealType === 'new' ? 'pdpLoadMoreDealsLoadingnew' : 'pdpLoadMoreDealsLoadingupgrade',
            dealType === 'new' ? 'pdpLoadMoreBtnTextnew' : 'pdpLoadMoreBtnTextupgrade'
        );
    };
    const showHidePdpLoader = (show, hide) => {
        if ($('.' + show).length) {
            document.querySelector('.' + show).classList.remove('hide');
        }
        if ($('.' + hide).length) {
            document.querySelector('.' + hide).classList.add('hide');
        }
    };
    const insertLoadedPdpDeals = (deals, loaderDealsContainer, dealType, resetPagination) => {
        if (resetPagination) {
            loaderDealsContainer.innerHTML = '';
        }
        loaderDealsContainer.insertAdjacentHTML('beforeend', deals);
        setTimeout(() => {
            equilisePdpDealsHeight(
                dealType === 'new'
                    ? '.pdp-deals-promo-paym'
                    : '.pdp-deals-promo-paymupgrade'
            );
        }, 0);
    };
    const insertLoadedPdpFilters = (filters, loaderFiltersContainer) => {
        loaderFiltersContainer.innerHTML = '';
        loaderFiltersContainer.insertAdjacentHTML('beforeend', filters);
        setTimeout(() => {
            initPdpFilters();
            initFilterApplyButtons();
        }, 0);
    };
    const destroyPdpLoader = (dealType) => {
        document.querySelectorAll(`.pdp-load-more-${dealType}`).forEach((el) => {
            el.classList.add('hide');
        });
    };
    const continuePdpLoader = (dealType) => {
        document.querySelectorAll(`.pdp-load-more-${dealType}`).forEach((el) => {
            el.classList.remove('hide');
        });
        showHidePdpLoader(
            dealType === 'new' ? 'pdpLoadMoreBtnTextnew' : 'pdpLoadMoreBtnTextupgrade',
            dealType === 'new' ? 'pdpLoadMoreDealsLoadingnew' : 'pdpLoadMoreDealsLoadingupgrade'
        );
        const pdpLoadMoreDealsButton = dealType === 'new'
            ? pdpLoadMoreDealsButtonPaym
            : pdpLoadMoreDealsButtonPaymUpgrade;
        pdpLoadMoreDealsButton.classList.remove('hide');
        pdpLoadMoreDealsButton.disabled = false;
        pdpLoadMoreDealsButton.style.pointerEvents = 'auto';
        pdpLoadMoreDealsButton.style.opacity = '1';
        pdpLoadMoreDealsButton.removeAttribute('aria-disabled');
    };
    const pdpPageLoader = (pdpLoadMoreDealsButton, initialize = true) => {
        pdpLoadMoreDealsButton.dataset.pageState = initialize ? 1 : pdpLoadMoreDealsButton.dataset.pageState;
        pdpSpinner.dataset.activeTasks = initialize ? '1' : '0';
        document.body.classList.toggle('noScrollToTop', initialize);
    };
    const pdpFocusNewFirstDeal = (newFirstDeal) => {
        newFirstDeal.focus();
        window.scrollTo({
            top: newFirstDeal.getBoundingClientRect().top + window.scrollY - 120,
            behavior: 'smooth'
        });
    };
    const pdpSortAssignment = (pdpSortSelector) => {
        const sortInput = document.getElementById(pdpSortSelector);
        pdpSortSelect.value = sortInput.value;
    };
    const processFilterNetwork = (handsetDealNetworkName) => {
        handsetDealNetworkName.dataset.filterStatus = handsetDealNetworkName.dataset.filterStatus === '1' ? '0' : '1';
        pdpFilterHandler((handsetDealNetworkName.dataset.dealType == 'paym') ? pdpLoadMoreDealsButtonPaym : pdpLoadMoreDealsButtonPaymUpgrade);
    };
    const pdpDealFilterToggle = (e, pdpDealFilter) => {
        e.preventDefault();
        pdpDealFilter.dataset.activeStatus = pdpDealFilter.dataset.activeStatus === '1' ? '0' : '1';
        const pdpFilterContainer = (pdpDealFilter.dataset.dealType == 'paym') ? pdpPaymDealFilterContainer : pdpPaymUpgradeDealFilterContainer;
        pdpFilterContainer.classList.toggle(
            'hide',
            pdpDealFilter.dataset.activeStatus !== '1'
        );
    };
    const processPdpFilters = (pdpFilterElement) => {
        pdpFilterElement.dataset.filterStatus = pdpFilterElement.dataset.filterStatus === '1' ? '0' : '1';
        // const pdpLoadMoreButton =
        //     pdpHandsetLoadMorePaym
        //         ? (pdpHandsetLoadMorePaym.classList.contains('hide')
        //             ? pdpLoadMoreDealsButtonPaymUpgrade
        //             : pdpLoadMoreDealsButtonPaym)
        //         : (pdpHandsetLoadMoreUpgrade.classList.contains('hide')
        //             ? pdpLoadMoreDealsButtonPaym
        //             : pdpLoadMoreDealsButtonPaymUpgrade);
        // pdpFilterHandler(pdpLoadMoreButton);
    };
    const pdpApplyFilter = (e, pdpApplyFilterBtn) => {
        e.preventDefault();
        pdpFilterHandler((pdpApplyFilterBtn.dataset.dealType == 'paym') ? pdpLoadMoreDealsButtonPaym : pdpLoadMoreDealsButtonPaymUpgrade);
    };
    const appendPdpActiveFilters = (url, dealType) => {
        document.querySelectorAll('.pdpFilters').forEach((el) => {
            if (el.dataset.filterStatus !== '1') {
                return;
            }
            if (el.dataset.dealType && el.dataset.dealType !== dealType) {
                return;
            }
            const filterName = el.dataset.filterName;
            const filterValue = el.dataset.filterValue;
            if (!url.searchParams.getAll(filterName).includes(filterValue)) {
                url.searchParams.append(filterName, filterValue);
            }
        });
    };
    const pdpFilterHandler = (pdpLoadMoreDealsButton, resetPagination = true) => {
        if (resetPagination) {
            pdpPageLoader(pdpLoadMoreDealsButton);
        }
        const pageState = pdpLoadMoreDealsButton.dataset.pageState;
        const dealType = pdpLoadMoreDealsButton.dataset.dealType;
        const url = new URL(document.URL);
        url.searchParams.append('page', pageState);
        url.searchParams.append('loadDealType', (dealType == 'new' ? 'paym' : 'paymupgrade'));
        appendPdpActiveFilters(url, (dealType == 'new') ? 'paym' : 'paymupgrade');
        const sortValue = document.getElementById(`pdpSort${dealType === 'new' ? 'Paym' : 'PaymUpgrade'}`).value.trim();
        if (sortValue) {
            url.searchParams.append('sort', sortValue);
        }
        fetch(url, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then(res => res.json())
            .then((data) => {
                const resultsRoot = (dealType == 'new') ? loaderPaymDealsContainer : loaderPaymUpgradeDealsContainer;
                const cardSelector = (dealType == 'new') ? '.handsetPaymShowHide' : '.handsetUpgradeShowHide';
                const oldCount = resultsRoot
                    ? resultsRoot.querySelectorAll(cardSelector).length
                    : 0;
                insertLoadedPdpDeals(data.listing.deals, resultsRoot, dealType, resetPagination);
                const allCards = resultsRoot.querySelectorAll(cardSelector);
                const firstNew = resetPagination ? allCards[0] : allCards[oldCount];
                document.querySelector(
                    `.${dealType == 'new' ? 'paym' : 'paymupgrade'}DealsCount`
                ).textContent = allCards.length;
                document.querySelector(
                    `.${dealType == 'new' ? 'paym' : 'paymupgrade'}TotalDealsCount`
                ).textContent = `${data.listing.numberOfResults} plan${data.listing.numberOfResults > 1 ? 's' : ''}`;
                document.querySelector(
                    `[pdp-deals-count-${dealType == 'new' ? 'paym' : 'paymupgrade'}]`
                ).textContent = `${data.listing.numberOfResults} plan${data.listing.numberOfResults > 1 ? 's' : ''}`;
                if (resetPagination) {
                    insertLoadedPdpFilters(data.listing.filterSummary, (dealType == 'new') ? pdpPaymDealFilterContainer : pdpPaymUpgradeDealFilterContainer);
                    pdpPageLoader(pdpLoadMoreDealsButton, false);
                }
                if (!firstNew) {
                    destroyPdpLoader(dealType);
                    return;
                }
                pdpFocusNewFirstDeal(firstNew);
                data.listing.isLastPage
                    ? destroyPdpLoader(dealType)
                    : continuePdpLoader(dealType);
            });
    };
    const init = () => {
        if (pdpLoadMoreDealsButtonPaym) {
            pdpLoadMoreDealsButtonPaym.addEventListener('click', (e) => {
                pdpLoadMoreDeals(e, pdpLoadMoreDealsButtonPaym);
            });
        }
        if (pdpLoadMoreDealsButtonPaymUpgrade) {
            pdpLoadMoreDealsButtonPaymUpgrade.addEventListener('click', (e) => {
                pdpLoadMoreDeals(e, pdpLoadMoreDealsButtonPaymUpgrade);
            });
        }
        if (pdpSortSelect) {
            pdpSortSelect.addEventListener('change', () => {
                sort();
            });
        }
        initPdpFilterNetworks();
        initFilterContainers();
        initPdpFilterToggle();
        initPdpFilters();
        initFilterApplyButtons();
    };
    document.addEventListener('DOMContentLoaded', () => {
        equilisePdpDeals();
    });
    window.addEventListener('resize', () => {
        // resetPdpDeals();
        equilisePdpDeals();
    });
    init();
    // CPW PDP SORT + LOAD MORE + FILTER ENDS
    $(document).ready(function() {
        let handsetOverViewContent = $('.handsetOverViewContent').outerHeight(true);
        let handserCrossSellBar = $('.handserCrossSellBarContents').outerHeight(true);
        let handsetOffersSection = $('.handsetOffersSection').outerHeight(true);
        if (handsetOverViewContent < 295) {
            $('.productInfoHandsetOverviewViewMore').remove();
            $('.overviewGradient').remove();
            if ($('.productInfoHandsetOverview').hasClass('handsetGradient')) {
                $('.productInfoHandsetOverview').removeClass('handsetGradient');
            }
        }
        if (handserCrossSellBar < 80) {
            if (!$('.handsetCrossSellBar').hasClass('hide')) {
                $('.handsetCrossSellBar').addClass('hide');
            }
            $('.productInfoHandsetFullSpecsDivider').addClass('marginB24');
        }
        if (handsetOffersSection < 50) {
            $('.handsetOffersSection').remove();
        }
        $(document).on('click', '.productInfoHandset', function(e) {
            e.preventDefault();
            let dataRef = $(this).attr('data-ref');
            let dataClass = $(this).attr('data-class');
            if ($('.' + dataRef).hasClass('hide')) {
                $(this).addClass('handset-pb-0');
                $('.deviceFullSpecsHandset' + dataClass).addClass('deviceFullSpecsHandsetP8');
                if (dataRef == 'productInfoHandsetOverview') {
                    if ($('.productInfoHandsetOverviewViewMore').length) {
                        $('.' + dataRef).addClass('handsetGradient');
                        $('.productInfoHandsetOverviewViewMore').removeClass('hide');
                        $('.overviewGradient').removeClass('hide');
                    }
                }
                $('.' + dataRef + 'Icon').html('\
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.14 13.483a.5.5 0 0 0 0 .698l1.465 1.502a.5.5 0 0 0 .716 0L12 10.886l4.679 4.797a.5.5 0 0 0 .716 0l1.465-1.502a.5.5 0 0 0 0-.698l-6.502-6.666a.5.5 0 0 0-.716 0l-6.501 6.666z" fill="#5A5B5C"></path>\
                    </svg>\
                ');
                if ($('.' + dataRef).hasClass('hide')) {
                    $('.' + dataRef).removeClass('hide');
                }
                if (dataRef == 'productInfoHandsetOverview') {
                    let handsetOverViewContent = $('.productInfoHandsetOverview').outerHeight(true);
                    if (handsetOverViewContent < 295) {
                        $('.productInfoHandsetOverviewViewMore').click();
                    }
                }
            } else {
                $(this).removeClass('handset-pb-0');
                $('.deviceFullSpecsHandset' + dataClass).removeClass('deviceFullSpecsHandsetP8');
                if (dataRef == 'productInfoHandsetOverview') {
                    if ($('.productInfoHandsetOverviewViewMore').length) {
                        if (!$('.productInfoHandsetOverviewViewMore').hasClass('hide')) {
                            $('.productInfoHandsetOverviewViewMore').addClass('hide');
                        }
                        if (!$('.overviewGradient').hasClass('hide')) {
                            $('.overviewGradient').addClass('hide');
                        }
                        if ($('.' + dataRef).hasClass('handsetGradient')) {
                            $('.' + dataRef).removeClass('handsetGradient');
                        }
                    }
                }
                $('.' + dataRef + 'Icon').html('\
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.14 10.517a.5.5 0 0 1 0-.698l1.465-1.502a.5.5 0 0 1 .716 0L12 13.114l4.679-4.797a.5.5 0 0 1 .716 0l1.465 1.502a.5.5 0 0 1 0 .698l-6.502 6.666a.5.5 0 0 1-.716 0l-6.501-6.666z" fill="#5A5B5C"></path>\
                    </svg>\
                ');
                $('.' + dataRef).addClass('hide');
            }
        });
        $(document).on('click', '.productInfoHandsetOverviewViewMore', function() {
            $('.productInfoHandsetOverviewIcon').html('\
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.14 13.483a.5.5 0 0 0 0 .698l1.465 1.502a.5.5 0 0 0 .716 0L12 10.886l4.679 4.797a.5.5 0 0 0 .716 0l1.465-1.502a.5.5 0 0 0 0-.698l-6.502-6.666a.5.5 0 0 0-.716 0l-6.501 6.666z" fill="#5A5B5C"></path>\
                </svg>\
            ');
            $(this).remove();
            $('.overviewGradient').remove();
            if ($('.productInfoHandsetOverview').hasClass('handsetGradient')) {
                $('.productInfoHandsetOverview').removeClass('handsetGradient');
            }
        });
        $(document).on('click', '.pdpTariffsHandsetTopIcon', function() {
            let dataRef = $(this).attr('data-ref');
            if ($('.xSPdpNetworkInfo' + dataRef).hasClass('blockHidden')) {
                $('.xSPdpNetworkInfo' + dataRef).removeClass('blockHidden');
                $(this).html('\
                    <svg width="20" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.14 13.483a.5.5 0 0 0 0 .698l1.465 1.502a.5.5 0 0 0 .716 0L12 10.886l4.679 4.797a.5.5 0 0 0 .716 0l1.465-1.502a.5.5 0 0 0 0-.698l-6.502-6.666a.5.5 0 0 0-.716 0l-6.501 6.666z" fill="#3A3A3A"></path>\
                    </svg>\
                ');
                $('.xSPdpNetworkInfo' + dataRef).show('slow');
            } else {
                $('.xSPdpNetworkInfo' + dataRef).addClass('blockHidden');
                $(this).html('\
                    <svg width="20" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.14 10.517a.5.5 0 0 1 0-.698l1.465-1.502a.5.5 0 0 1 .716 0L12 13.114l4.679-4.797a.5.5 0 0 1 .716 0l1.465 1.502a.5.5 0 0 1 0 .698l-6.502 6.666a.5.5 0 0 1-.716 0l-6.501-6.666z" fill="#3A3A3A"></path>\
                    </svg>\
                ');
                $('.xSPdpNetworkInfo' + dataRef).hide('slow');
            }
        });
        $(document).on('click', '.selectHansetDealType', function(e) {
            e.preventDefault();
            let dataShow = $(this).attr('data-show');
            let dataHide = $(this).attr('data-hide');
            $('.put' + dataHide + 'Checked')
                .addClass('hide')
                .removeClass('handsetContractChecked');
            $('.put' + dataShow + 'Checked')
                .removeClass('hide')
                .addClass('handsetContractChecked');
            $('.handset' + dataShow + 'Deal').addClass('paymentChecked');
            $('.handset' + dataHide + 'Deal').removeClass('paymentChecked');
            let contractTypeShow = ($('#defaultContractType').val() == 'paym') ? 'Paym' : 'PaymUpgrade';
            let contractTypeHide = ($('#defaultContractType').val() == 'paym') ? 'PaymUpgrade' : 'Paym';
            if (dataShow == 'Contract') {
                $('.simFreePriceHandsetParent').addClass('hide');
                $('.handsetContractOption').removeClass('hide');
                $('.put' + contractTypeHide + 'Checked')
                    .addClass('hide')
                    .removeClass('handsetContractChecked');
                $('.put' + contractTypeShow + 'Checked')
                    .removeClass('hide')
                    .addClass('handsetContractChecked');
                $('.handset' + contractTypeShow + 'Deal').addClass('paymentChecked');
                $('.handset' + contractTypeHide + 'Deal').removeClass('paymentChecked');
                $('.handsetDealList, .handsetDealListContract').removeClass('hide');
                pdpShowContractPriceTab();
                if (contractTypeShow == 'Paym') {
                    $('.handsetLoadMoreUpgrade').addClass('hide');
                    $('.handsetLoadMorePaym').removeClass('hide');
                    $('.handsetPaymShowHide').removeClass('hide');
                    $('.handsetUpgradeShowHide').addClass('hide');
                    $('.handsetDealTypeName').text('new');
                    $('.handsetContractDealPaymUpgrade').addClass('hide').removeClass('paymentChecked');
                    $('.handsetContractDealPaym').removeClass('hide').addClass('paymentChecked');
                    $('.handsetDealTypeNetworkPaymUpgrade').addClass('hide');
                    $('.handsetDealTypeNetworkPaym').removeClass('hide');
                    $('.handsetDealTypeFilterPaymUpgrade').addClass('hide');
                    $('.handsetDealTypeFilterPaym').removeClass('hide');
                    showHideHiddenTag('Paym', 'PaymUpgrade', 'Simfree');
                    showHidePromotionTag('showPaymPromo', 'showPaymUpgPromo', 'showSimfPromo');
                    showHidePriceDrip('PaymPriceDrip', 'PaymUpgradePriceDrip');
                    equilisePdpDealsHeight('.pdp-deals-promo-paym');
                    pdpSortAssignment('pdpSortPaym');
                    initFilterContainers();
                }
                if (contractTypeShow == 'PaymUpgrade') {
                    $('.handsetLoadMoreUpgrade').removeClass('hide');
                    $('.handsetLoadMorePaym').addClass('hide');
                    $('.handsetPaymShowHide').addClass('hide');
                    $('.handsetUpgradeShowHide').removeClass('hide');
                    $('.handsetDealTypeName').text('upgrade');
                    $('.handsetContractDealPaym').addClass('hide').removeClass('paymentChecked');
                    $('.handsetContractDealPaymUpgrade').removeClass('hide').addClass('paymentChecked');
                    $('.handsetDealTypeNetworkPaym').addClass('hide');
                    $('.handsetDealTypeNetworkPaymUpgrade').removeClass('hide');
                    $('.handsetDealTypeFilterPaym').addClass('hide');
                    $('.handsetDealTypeFilterPaymUpgrade').removeClass('hide');
                    showHideHiddenTag('PaymUpgrade', 'Paym', 'Simfree');
                    showHidePromotionTag('showPaymUpgPromo', 'showPaymPromo', 'showSimfPromo');
                    showHidePriceDrip('PaymUpgradePriceDrip', 'PaymPriceDrip');
                    equilisePdpDealsHeight('.pdp-deals-promo-paymupgrade');
                    pdpSortAssignment('pdpSortPaymUpgrade');
                    initFilterContainers();
                }
                // $('html, body').animate({
                //     scrollTop: $('.handsetContractOption').offset().top - 65
                // }, 'slow');
            }
            if (dataShow == 'Simfree') {
                $('.simFreePriceHandsetParent').removeClass('hide');
                $('.handsetContractOption').addClass('hide');
                // Below line should be removed in Handset PDP 2.0
                $('.handsetDealList').addClass('hide');
                $('.handsetLoadMorePaym').addClass('hide');
                $('.handsetLoadMoreUpgrade').addClass('hide');
                $('.handsetPaymShowHide').addClass('hide');
                $('.handsetUpgradeShowHide').addClass('hide');
                showHideHiddenTag('Simfree', 'Paym', 'PaymUpgrade');
                showHidePromotionTag('showSimfPromo', 'showPaymPromo', 'showPaymUpgPromo');
                showHidePriceDrip('', '');
                pdpHideContractPriceTab();
            }
            if (dataShow == 'Paym') {
                $('.handsetLoadMoreUpgrade').addClass('hide');
                $('.handsetLoadMorePaym').removeClass('hide');
                $('.handsetPaymShowHide').removeClass('hide');
                $('.handsetUpgradeShowHide').addClass('hide');
                $('.handsetDealTypeName').text('new');
                $('.handsetContractDealPaymUpgrade').addClass('hide').removeClass('paymentChecked');
                $('.handsetContractDealPaym').removeClass('hide').addClass('paymentChecked');
                $('.handsetDealTypeNetworkPaymUpgrade').addClass('hide');
                $('.handsetDealTypeNetworkPaym').removeClass('hide');
                $('.handsetDealTypeFilterPaymUpgrade').addClass('hide');
                $('.handsetDealTypeFilterPaym').removeClass('hide');
                showHideHiddenTag('Paym', 'PaymUpgrade', 'Simfree');
                showHidePromotionTag('showPaymPromo', 'showPaymUpgPromo', 'showSimfPromo');
                showHidePriceDrip('PaymPriceDrip', 'PaymUpgradePriceDrip');
                equilisePdpDealsHeight('.pdp-deals-promo-paym');
                pdpSortAssignment('pdpSortPaym');
                initFilterContainers();
            }
            if (dataShow == 'PaymUpgrade') {
                $('.handsetLoadMoreUpgrade').removeClass('hide');
                $('.handsetLoadMorePaym').addClass('hide');
                $('.handsetPaymShowHide').addClass('hide');
                $('.handsetUpgradeShowHide').removeClass('hide');
                $('.handsetDealTypeName').text('upgrade');
                $('.handsetContractDealPaym').addClass('hide').removeClass('paymentChecked');
                $('.handsetContractDealPaymUpgrade').removeClass('hide').addClass('paymentChecked');
                $('.handsetDealTypeNetworkPaym').addClass('hide');
                $('.handsetDealTypeNetworkPaymUpgrade').removeClass('hide');
                $('.handsetDealTypeFilterPaym').addClass('hide');
                $('.handsetDealTypeFilterPaymUpgrade').removeClass('hide');
                showHideHiddenTag('PaymUpgrade', 'Paym', 'Simfree');
                showHidePromotionTag('showPaymUpgPromo', 'showPaymPromo', 'showSimfPromo');
                showHidePriceDrip('PaymUpgradePriceDrip', 'PaymPriceDrip');
                equilisePdpDealsHeight('.pdp-deals-promo-paymupgrade');
                pdpSortAssignment('pdpSortPaymUpgrade');
                initFilterContainers();
            }
            // set aria-current true attribute
            $('.payment-toggle-handset > span').each(function() {
                $(this).removeAttr('aria-current');
                if ($(this).hasClass('paymentChecked') && !$(this).hasClass('hide')) {
                    $(this).attr('aria-current', 'true');
                }
            });
        });
        $(document).on('click', '.scrollable-nav-handset', function(e) {
            e.preventDefault();
            let dataRef = $(this).attr('data-selector');
            $('html, body').animate({
                scrollTop: $(dataRef).offset().top - 90
            }, 'slow');
            if ($('.productInfoHandsetFullSpecs').hasClass('hide')) {
                $('.productInfoHandsetFullSpecs').removeClass('hide');
                $('.productInfoHandsetFullSpecsIcon').html('\
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.14 13.483a.5.5 0 0 0 0 .698l1.465 1.502a.5.5 0 0 0 .716 0L12 10.886l4.679 4.797a.5.5 0 0 0 .716 0l1.465-1.502a.5.5 0 0 0 0-.698l-6.502-6.666a.5.5 0 0 0-.716 0l-6.501 6.666z" fill="#5A5B5C"></path>\
                    </svg>\
                ');
            }
        });
        $(document).on('focus mouseenter mouseleave hover', '.color-capacity-href, .viewDealsCta, .buyNowCta', function() {
            handleHrefUrl($(this));
        });
        $(document).on('click', '.color-capacity-href, .viewDealsCta, .buyNowCta', function(e) {
            e.preventDefault();
            let href = $(this).attr('href');
            let orgHref = $(this).attr('data-org-url');
            if (href != orgHref) {
                if (getCookie('hiddenAffiliateId') != '') {
                    window.location.href = href;
                } else {
                    $(this).attr('href', orgHref);
                    window.location.href = orgHref;
                }
            } else {
                window.location.href = href;
            }
        });
        if ($('#pdpDealData').length) {
            let pdpDealData = JSON.parse($('#pdpDealData').val());
            if (pdpDealData.prodIdUrl != '' && pdpDealData.isHidden == 'true') {
                setHiddenAffiliateIdCookie(pdpDealData);
            }
        }
        $(document).on('click', '.navTanPresentation', function() {
            if ($('.deviceUspWrapPromotionShowHide').length && !$('.deviceUspWrapPromotionShowHide').hasClass('hideImp')) {
                $('.deviceUspWrapPromotionShowHide').addClass('hideImp');
            }
            let $this = $(this);
            let showDataRef = ($this.attr('data-ref-hidden') == 'Paym') ? 'showPaymPromo' : 'showPaymUpgPromo';
            let hideDataRef = ($this.attr('data-ref-hidden') == 'Paym') ? 'showPaymUpgPromo' : 'showPaymPromo';
            if ($('.deviceUspWrapPromotionShowHide').length) {
                $('.deviceUspWrapPromotionShowHide').each(function() {
                    if ($(this).hasClass(showDataRef) && $(this).hasClass('hideImp')) {
                        $(this).removeClass('hideImp');
                    }
                    if ($(this).hasClass(hideDataRef) && !$(this).hasClass('hideImp')) {
                        $(this).addClass('hideImp');
                    }
                });
            }
        });
        handleProdIdUrl();
        handlePdpBreadCrumbsCta();
        setEqualHeight();
        feefoScript();
    });
    let dataShow = $('.handset-payment-parent').find('span.handsetContractDeal.paymentChecked').attr('data-show');
    let contractTypeShow = ($('#defaultContractType').val() == 'paym') ? 'Paym' : 'PaymUpgrade';
    if (!$('.payment-toggle-handset').hasClass('payment-out-of-stock')) {
        if (dataShow == 'Contract') {
            if (contractTypeShow == 'PaymUpgrade') {
                showHidePriceDrip('PaymUpgradePriceDrip', 'PaymPriceDrip');
            }
            if (contractTypeShow == 'Paym') {
                showHidePriceDrip('PaymPriceDrip', 'PaymUpgradePriceDrip');
            }
        }
    }
    if ($('.handset-payment-parent .payment-toggle-handset .handsetContractDeal').hasClass('payment-out-of-stock')) {
        if ($('.PaymPriceDrip').length) {
            if (!$('.PaymPriceDrip').hasClass('hide')) {
                $('.PaymPriceDrip').addClass('hide');
            }
        }
        if ($('.PaymUpgradePriceDrip').length) {
            if (!$('.PaymUpgradePriceDrip').hasClass('hide')) {
                $('.PaymUpgradePriceDrip').addClass('hide');
            }
        }
    }
};
export default pdpFilter;
